import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { Action, handleAction } from "./Action";
import Icon from "./Icon";

export default function ActionIconButton({
  action,
  tooltipText = "",
}: {
  action: Action;
  tooltipText?: string;
}) {
  return (
    <Tooltip title={tooltipText} placement="top" disableInteractive>
      <span style={{ display: 'inline-block' }}>
        <IconButton
          disabled={action.disabled}
          onClick={() => handleAction(action)}
          size="large"
        >
          <Icon fontIconClass={action.iconClass || ""} />
        </IconButton>
      </span>
    </Tooltip>
  );
}
